import dynamic from 'next/dynamic';
import DocumentHead from '@/components/DocumentHead';
import createTheme from '@orgnc/core/lib/themes/createTheme';
import getConfig from 'next/config';
import Footer from '@/components/Footer';
import elementsTheme from '@orgnc/core/components/themes/Default';
import directoryCategoriesQuery from '@/lib/queries/directoryCategoriesQuery';
import ElementsDefaultPageTemplate from '@orgnc/core/components/themes/Elements/components/templates/Page';
import getArticleTemplate from '@orgnc/core/lib/themes/templates/functions/getArticleTemplate';
import getCategoryTemplate from '@orgnc/core/lib/themes/templates/functions/getCategoryTemplate';
import { GetPageTemplate } from '@orgnc/core/lib/themes/templates/functions/getPageTemplate';
import { getPageTemplateByName } from '@orgnc/core/lib/themes/templates/page';
import postCommentsQuery from '@orgnc/core/lib/wordpress/api/queries/postCommentsQuery';
import ArticleTemplate from '@/components/templates/Article/ArticleTemplate';
import SimpleGridLayout from '@/components/blocks/ArticleList/SimpleGridLayout';
import CircularCardLayout from '@/components/blocks/ArticleList/CircularCardLayout';
import AcfTopStoryBlockArticleLayout from '@/components/blocks/AcfTopStoryBlock/AcfTopStoryBlockArticleLayout';
import AcfTopStoryBlockHeroLayout from '@/components/blocks/AcfTopStoryBlock/AcfTopStoryBlockHeroLayout';
import AcfTopStoryBlockHeroLayoutWSN from '@/components/blocks/AcfTopStoryBlock/AcfTopStoryBlockHeroLayoutWSN';
import * as headers from '@/components/header';
import acfFullWidthCallToActionBlockFragment from '@/lib/queries/acfFullWidthCallToActionBlockFragment';
import MainArticleGridLayout from '@/components/blocks/ArticleList/MainArticleGridLayout';
import MainRecentArticleGridLayout from '@/components/blocks/ArticleList/MainRecentArticleGridLayout';
import acfScriptmagArticlesShowcaseFragment from '@/lib/queries/acfScriptmagArticlesShowcaseFragment';
import DefaultHomepageTemplate from '@/components/templates/Homepage/DefaultHomepageTemplate';
import HortmagHomepageTemplate from '@/components/templates/Homepage/HortmagHomepageTemplate';
import ArticleGridAdsAndFeaturedLayout from '@/components/blocks/ArticleList/ArticleGridAdsAndFeaturedLayout';
import TraditionalBuildingHomepageTemplate from '@/components/templates/Homepage/TraditionalBuildingHomepageTemplate';
import TraditionalBuildingShowHomepageTemplate from '@/components/templates/Homepage/TraditionalBuildingShowHomepageTemplate';
import SportsCollectorsDigestHomepageTemplate from '@/components/templates/Homepage/SportsCollectorsDigestHomepageTemplate';
import ArticlesGalleryAndAdsLayout from '@/components/blocks/ArticleList/ArticlesGalleryAndAdsLayout';
import AcfArticleShowcaseSplitLayout from '@/components/blocks/AcfArticleShowcase/AcfArticleShowcaseSplitLayout';
import AcfArticleShowcaseLayout from '@/components/blocks/AcfArticleShowcase/AcfArticleShowcaseLayout';
import ArticlesGallerySplitLayout from '@/components/blocks/ArticleList/ArticlesGallerySplitLayout';
import ArticlesGalleryQuadSplitLayout from '@/components/blocks/ArticleList/ArticlesGalleryMultiSplitLayout';
import TbsArticleGridLayout from '@/components/blocks/ArticleList/TbsArticleGridLayout';
import GoogleAdTagBlock from '@/components/blocks/GoogleAdTagBlock';
import WoodshopnewsHomepageTemplate from '@/components/templates/Homepage/WoodshopnewsHomepageTemplate';
import AcfArticleShowcaseLayoutWSN from '@/components/blocks/AcfArticleShowcase/AcfArticleShowcaseLayoutWSN';
import AcfArticleShowcaseLayoutSquaredWSN from '@/components/blocks/AcfArticleShowcase/AcfArticleShowcaseLayoutSquaredWSN';
import WsnArticleGridAdsAndFeaturedLayout from '@/components/blocks/ArticleList/WsnArticleGridAdsAndFeaturedLayout';
import WritersdigestPageTemplate from '@/components/templates/Page/WritersdigestPageTemplate';
import WdArticleGridAdsLayout from '@/components/blocks/ArticleList/WdArticleGridAdsLayout';
import WdArticleGridNoAdsLayout from '@/components/blocks/ArticleList/WdArticleGridNoAdsLayout';
import WdRecentArticleGridLayout from '@/components/blocks/ArticleList/WdRecentArticleGridLayout';
import WdArticleTemplate from '@/components/templates/Article/WdArticleTemplate';
import AcfTopStoryBlockArticleExcerptLayout from '@/components/blocks/AcfTopStoryBlock/AcfTopStoryBlockArticleExcerptLayout';
import AchCircularCardLayout from '@/components/blocks/ArticleList/AchCircularCardLayout';
import AcfCategoriesGridBlock from '@/components/blocks/AcfCategoriesGridBlock';
import acfCategoriesGridBlockFragment from '@/lib/queries/acfCategoriesGridBlockFragment';
import PeriodHomesHomepageTemplate from '@/components/templates/Homepage/PeriodHomesHomepageTemplate';
import AcfTopStoryBlockHeroLayoutACH from '@/components/blocks/AcfTopStoryBlock/AcfTopStoryBlockHeroLayoutACH';
import ArtsCraftsHomesHomepageTemplate from '@/components/templates/Homepage/ArtsCraftsHomesHomepageTemplate';
import AchArticleGridLayout from '@/components/blocks/ArticleList/AchArticleGridLayout';
import AchArticleGridLayout3col from '@/components/blocks/ArticleList/AchArticleGridLayout3col';
import NnArticlesListLayout from '@/components/blocks/ArticleList/NnArticlesListLayout';
import AchArticleGridLayout3colExcerpt from '@/components/blocks/ArticleList/AchArticleGridLayout3colExcerpt';
import AcfTopStoryBlockHeroLayoutNN from '@/components/blocks/AcfTopStoryBlock/AcfTopStoryBlockHeroLayoutNN';
import NnArticlesList4colLayout from '@/components/blocks/ArticleList/NnArticlesList4colLayout';
import NumismaticNewsHomepageTemplate from '@/components/templates/Homepage/NumismaticNewsHomepageTemplate';
import NnRecentArticleGridLayout from '@/components/blocks/ArticleList/NnRecentArticleGridLayout';
import NnRecentArticlesGridLayout from '@/components/blocks/ArticleList/NnRecentArticlesGridLayout';
import NnArticleTemplate from '@/components/templates/Article/NnArticleTemplate';
import AchArticleTemplate from '@/components/templates/Article/AchArticleTemplate';
import MtMvArticleGridAdsLayout from '@/components/blocks/ArticleList/MtMvArticleGridAdsLayout';
import MtArticleGridAdsLayout from '@/components/blocks/ArticleList/MtArticleGridAdsLayout';
import WritersDigestHomepageTemplate from '@/components/templates/Homepage/WritersDigestHomepageTemplate';
import OldsCarWeeklyHomepageTemplate from '@/components/templates/Homepage/OldsCarWeeklyHomepageTemplate';
import AntiqueTraderHomepageTemplate from '@/components/templates/Homepage/AntiqueTraderHomepageTemplate';
import directorySponsoredPostsQuery from '@/lib/queries/directorySponsoredPostsQuery';
import directoryFeaturedPostsQuery from '@/lib/queries/directoryFeaturedPostsQuery';
import directoryPostsQuery from '@/lib/queries/directoryPostsQuery';
import DirectoryTemplate from '@/components/templates/Category/DirectoryTemplate';
import AchDirectoryChildTemplateContent from '@/components/templates/Category/artsandcraftshomes/AchDirectoryChildTemplateContent';
import MtDirectoryTemplateContent from '@/components/templates/Category/militarytrader/MtDirectoryTemplateContent';
import DirectoryTemplateContent from '@/components/templates/Category/default/DirectoryTemplateContent';
import ScdDirectoryTemplateContent from '@/components/templates/Category/sportscollectorsdigest/ScdDirectoryTemplateContent';
import AtDirectoryTemplateContent from '@/components/templates/Category/antiquetrader/AtDirectoryTemplateContent';
import ScdArticleTemplate from '@/components/templates/Article/ScdArticleTemplate';
import TbArticleTemplate from '@/components/templates/Article/TbArticleTemplate';
import PhArticleTemplate from '@/components/templates/Article/PhArticleTemplate';
import TbsArticleTemplate from '@/components/templates/Article/TbsArticleTemplate';
import DefaultHeader from '@/components/header/default-header/header';
import { getTheme, MultiTheme } from '@orgnc/core/lib/themes/multiTheme';
import PageWithBuyingGuideSpotlight from '@/components/templates/Page/PageWithBuyingGuideSpotlight';
import AcfTopStoryBlockHeroLayoutPH from './components/blocks/AcfTopStoryBlock/AcfTopStoryBlockHeroLayoutPH';
import TbDirectoryTemplateContent from './components/templates/Category/traditionalbuilding/TbDirectoryTemplateContent';
import AcfTopStoryBlockHeroLayoutOW from './components/blocks/AcfTopStoryBlock/AcfTopStoryBlockHeroLayoutOW';
import OwMainRecentArticleGridLayout from './components/blocks/ArticleList/OwMainRecentArticleGridLayout';
import CategoryTemplate from './components/templates/Category/CategoryTemplate';
import PhDirectoryTemplateContent from './components/templates/Category/periodhomes/PhDirectoryTemplateContent';
import PhDirectoryChildTemplateContent from './components/templates/Category/periodhomes/PhDirectoryChildTemplateContent';
import aimGeneralOptionsQuery from './lib/queries/aimGeneralOptionsQuery';
import postExtraFieldsQuery from './lib/queries/postExtraFieldsQuery';
import * as themes from './themes';
import { getHostname, SiteId } from './themes';
import {
  getDirectoryPath,
  getDirectoryPathSegments,
  getDirectoryTemplate,
  DIRECTORY_TEMPLATE_NAME,
} from './utils/directory';
import AchDirectoryTemplateContent from './components/templates/Category/artsandcraftshomes/AchDirectoryTemplateContent';
import AcfCategoryArticleListBlock from './components/blocks/AcfCategoryArticleListBlock';
import acfCategoryArticleListBlockFragment from './lib/queries/acfCategoryArticleListBlockFragment';

const nextConfig = getConfig();
const DEFAULT_TEMPLATE_NAME = 'default';

// Dynamic imports
const FullWidthCallToAction = dynamic(
  () => import('@/components/blocks/FullWidthCallToAction')
);

// Article list layout mappings for all themes
const articleListLayoutMappings: Record<string, React.ComponentType<any>> = {
  'hortmag-simple-grid': SimpleGridLayout,
  'hortmag-circular-card': CircularCardLayout,
  'scriptmag-main-grid': MainArticleGridLayout,
  'scriptmag-main-recent-grid': MainRecentArticleGridLayout,
  'scriptmag-main-showcase': AcfArticleShowcaseLayout as any,
  'article-list-with-ads-and-featured': ArticleGridAdsAndFeaturedLayout,
  'gallery-and-ads': ArticlesGalleryAndAdsLayout,
  'gallery-split': ArticlesGallerySplitLayout,
  'gallery-quad-split': ArticlesGalleryQuadSplitLayout,
  'tbs-article-grid': TbsArticleGridLayout,
  'wsn-article-showcase': AcfArticleShowcaseLayoutWSN as any,
  'wsn-article-showcase-sq': AcfArticleShowcaseLayoutSquaredWSN as any,
  'wsn-article-list-ads-features': WsnArticleGridAdsAndFeaturedLayout,
  'wd-article-grid-ads': WdArticleGridAdsLayout,
  'wd-article-grid-no-ads': WdArticleGridNoAdsLayout,
  'wd-recent-article-grid': WdRecentArticleGridLayout,
  'ach-circular-card': AchCircularCardLayout,
  'ach-article-grid': AchArticleGridLayout,
  'ach-article-grid-3-col': AchArticleGridLayout3col,
  'ach-article-grid-3-col-ex': AchArticleGridLayout3colExcerpt,
  'mt-article-grid-ads': MtArticleGridAdsLayout,
  'mt-article-grid-ads-mv': MtMvArticleGridAdsLayout,
  'nn-articles-list': NnArticlesListLayout,
  'nn-articles-list-4-col': NnArticlesList4colLayout,
  'nn-recent-article-grid': NnRecentArticleGridLayout,
  'nn-recent-articles-grid': NnRecentArticlesGridLayout,
  'ow-recent-grid': OwMainRecentArticleGridLayout,
};

const ARTICLE_TEMPLATE_OPTIONS = {
  variant: 'small',
  disableFeaturedImage: true,
};

const baseTheme = createTheme({
  ...elementsTheme,
  _document: {
    Head: DocumentHead,
  },
  Header: DefaultHeader,
  Footer,
  extend: {
    blocks: [
      {
        name: 'acf/full-width-call-to-action',
        component: FullWidthCallToAction,
        fragment: acfFullWidthCallToActionBlockFragment,
      },
      {
        name: 'acf/categories-grid',
        component: AcfCategoriesGridBlock as any,
        fragment: acfCategoriesGridBlockFragment,
      },
      {
        name: 'google-ad-tag',
        component: GoogleAdTagBlock,
      },
      {
        name: 'acf/category-article-list',
        component: AcfCategoryArticleListBlock,
        fragment: acfCategoryArticleListBlockFragment,
      },
    ],
    queries: {
      global: [aimGeneralOptionsQuery as any],
    },
  },
  graphqlClient: {
    useMultiTenantConfig: true,
  },
  redisCache: {
    useMultiTenantConfig: true,
  },
  options: {
    allowEmptyCategories: true,
    articleListBlockCustomLayouts: articleListLayoutMappings,
    openExternalLinksInNewTab: true,
  },
  pageTypes: {
    // Default to the base page types
    ...elementsTheme.pageTypes,

    article: {
      templates: [
        {
          name: DEFAULT_TEMPLATE_NAME,
          component: ArticleTemplate,
          options: ARTICLE_TEMPLATE_OPTIONS,
          queries: [postCommentsQuery, postExtraFieldsQuery],
        },
        {
          name: SiteId.ARTSANDCRAFTSHOMES,
          component: AchArticleTemplate,
          options: ARTICLE_TEMPLATE_OPTIONS,
          queries: [postCommentsQuery, postExtraFieldsQuery],
        },
        {
          name: SiteId.WRITERSDIGEST,
          component: WdArticleTemplate,
          options: ARTICLE_TEMPLATE_OPTIONS,
          queries: [postCommentsQuery, postExtraFieldsQuery],
        },
        {
          name: SiteId.NUMISMATICNEWS,
          component: NnArticleTemplate,
          options: ARTICLE_TEMPLATE_OPTIONS,
          queries: [postCommentsQuery, postExtraFieldsQuery],
        },
        {
          name: SiteId.SPORTSCOLLECTORSDIGEST,
          component: ScdArticleTemplate,
          options: ARTICLE_TEMPLATE_OPTIONS,
          queries: [postCommentsQuery, postExtraFieldsQuery],
        },
        {
          name: SiteId.TRADITIONALBUILDING,
          component: TbArticleTemplate,
          options: ARTICLE_TEMPLATE_OPTIONS,
          queries: [postCommentsQuery, postExtraFieldsQuery],
        },
        {
          name: SiteId.TRADITIONALBUILDINGSHOW,
          component: TbsArticleTemplate,
          options: ARTICLE_TEMPLATE_OPTIONS,
          queries: [postCommentsQuery, postExtraFieldsQuery],
        },
        {
          name: SiteId.PERIOD_HOMES,
          component: PhArticleTemplate,
          options: ARTICLE_TEMPLATE_OPTIONS,
          queries: [postCommentsQuery, postExtraFieldsQuery],
        },
      ],
      getTemplate: (article, _themeSettings, theme) => {
        const defaultTemplate = getArticleTemplate(article, theme);

        const themeTemplateConfig = theme.pageTypes.article.templates.find(
          (t) => t.name === theme.themeId
        );

        return themeTemplateConfig !== undefined
          ? themeTemplateConfig
          : defaultTemplate;
      },
    },
    category: {
      templates: [
        {
          name: DEFAULT_TEMPLATE_NAME,
          component: CategoryTemplate,
          options: {
            subcategoryTagVariant: 'large',
          },
        },
        {
          name: SiteId.HORTMAG,
          component: CategoryTemplate,
          options: {
            subcategoryTagVariant: 'large',
            shouldDisplayRootCategoryBreadcrumbs: true,
          },
        },
        {
          name: SiteId.ARTSANDCRAFTSHOMES,
          component: CategoryTemplate,
          options: {
            subcategoryTagVariant: 'large',
          },
        },
        {
          name: SiteId.PERIOD_HOMES,
          component: CategoryTemplate,
          queries: [directoryCategoriesQuery],
          options: {
            subcategoryTagVariant: 'large',
            sx: {
              [`[data-rawhtml="1"] p > a`]: {
                color: '#a00000 !important',
                textDecorationColor: '#a00000 !important',
                transition: '.2s ease',
                '&:hover': {
                  filter: 'brightness(1.6)',
                },
              },
            },
          },
        },
        {
          name: SiteId.WOODSHOPNEWS,
          component: CategoryTemplate,
          options: {
            subcategoryTagVariant: 'large',
            sx: {
              [`a.MuiTypography-root.MuiTypography-overline`]: {
                color: 'text.primary',
              },
            },
          },
        },
      ],
      getTemplate: (category, themeSettings, theme) => {
        const themeSpecificTemplate = theme.pageTypes.category.templates.find(
          (t) => t.name === theme.themeId
        );

        const defaultTemplate = getCategoryTemplate(
          category,
          themeSettings,
          theme
        );
        const categoryTemplate =
          themeSpecificTemplate !== undefined
            ? themeSpecificTemplate
            : defaultTemplate;

        const directoryTemplate = getDirectoryTemplate(theme);
        const directoryPath = getDirectoryPath(
          directoryTemplate,
          category.category.uri ?? undefined
        );

        // Check if this is a directory path that should use special templates
        if (directoryTemplate !== undefined && directoryPath !== undefined) {
          const segments = getDirectoryPathSegments(
            category.category.uri ?? undefined,
            directoryPath
          );

          // Root directory category
          if (segments.length === 0) {
            return {
              ...categoryTemplate,
              component: directoryTemplate.component,
              options: {
                ...categoryTemplate.options,
                contentComponent: directoryTemplate.rootContent,
              },
              queries: [
                directoryCategoriesQuery,
                directoryPostsQuery,
                directoryFeaturedPostsQuery,
                directorySponsoredPostsQuery,
              ],
            };
          }

          // Child directory category
          if (segments.length >= 1) {
            return {
              ...categoryTemplate,
              component: directoryTemplate.component,
              options: {
                ...categoryTemplate.options,
                contentComponent: directoryTemplate.childContent,
              },
              queries: [
                directoryPostsQuery,
                directoryFeaturedPostsQuery,
                directorySponsoredPostsQuery,
              ],
            };
          }
        }

        return categoryTemplate;
      },
    },

    page: {
      templates: [
        {
          name: DEFAULT_TEMPLATE_NAME,
          component: ElementsDefaultPageTemplate,
        },
        {
          name: 'with-buying-guide-spotlight',
          component: PageWithBuyingGuideSpotlight,
        },
      ],
      getTemplate: ((page, _themeSettings, theme) => {
        if (page.uri === '/') {
          return getPageTemplateByName(theme, 'Homepage');
        }

        if (
          [SiteId.PERIOD_HOMES, SiteId.TRADITIONALBUILDING].includes(
            theme.themeId as SiteId
          )
        ) {
          return getPageTemplateByName(theme, 'with-buying-guide-spotlight');
        }

        return getPageTemplateByName(theme, DEFAULT_TEMPLATE_NAME);
      }) as GetPageTemplate,
    },
  },
});

export const multiTheme = {
  base: baseTheme,
  variations: {
    [SiteId.HORTMAG]: {
      muiTheme: themes.hortmag,
      Header: headers.HortmagHeader,
      extend: {
        blocks: [
          {
            name: 'acf/scriptmag-articles-showcase',
            component: AcfArticleShowcaseLayout,
            fragment: acfScriptmagArticlesShowcaseFragment,
          },
        ],
      },
      options: {
        disqusSiteIdentifier:
          nextConfig.publicRuntimeConfig?.disqusSiteIdentifier[SiteId.HORTMAG],
        adConfig: nextConfig.publicRuntimeConfig?.adConfig[SiteId.HORTMAG],
      },
      pageTypes: {
        page: {
          templates: [
            {
              name: 'Homepage',
              component: HortmagHomepageTemplate,
            },
          ],
        },
      },
    },
    [SiteId.ARTSANDCRAFTSHOMES]: {
      muiTheme: themes.artsandcraftshomes,
      Header: headers.ArtsandcraftsHomes,
      extend: {
        blocks: [
          {
            name: 'acf/scriptmag-articles-showcase',
            component: AcfArticleShowcaseLayout,
            fragment: acfScriptmagArticlesShowcaseFragment,
          },
        ],
      },
      blocks: {
        components: {
          AcfTopStoryBlock: AcfTopStoryBlockHeroLayoutACH,
        },
      },
      options: {
        disqusSiteIdentifier:
          nextConfig.publicRuntimeConfig?.disqusSiteIdentifier[
            SiteId.ARTSANDCRAFTSHOMES
          ],
        adConfig:
          nextConfig.publicRuntimeConfig?.adConfig[SiteId.ARTSANDCRAFTSHOMES],
      },
      pageTypes: {
        category: {
          templates: [
            {
              name: DIRECTORY_TEMPLATE_NAME,
              component: DirectoryTemplate,
              options: {
                paths: ['/products-and-services-directory'],
                rootContent: AchDirectoryTemplateContent,
                childContent: AchDirectoryChildTemplateContent,
              },
            },
          ],
        },
        page: {
          templates: [
            {
              name: 'Homepage',
              component: ArtsCraftsHomesHomepageTemplate,
            },
          ],
        },
      },
    },
    [SiteId.WOODSHOPNEWS]: {
      muiTheme: themes.woodshopnews,
      Header: headers.WoodshopnewsHeader,
      extend: {
        blocks: [
          {
            name: 'acf/scriptmag-articles-showcase',
            component: AcfArticleShowcaseLayout,
            fragment: acfScriptmagArticlesShowcaseFragment,
          },
        ],
      },
      blocks: {
        components: {
          AcfTopStoryBlock: AcfTopStoryBlockHeroLayoutWSN,
        },
      },
      options: {
        disqusSiteIdentifier:
          nextConfig.publicRuntimeConfig?.disqusSiteIdentifier[
            SiteId.WOODSHOPNEWS
          ],
        adConfig: nextConfig.publicRuntimeConfig?.adConfig[SiteId.WOODSHOPNEWS],
      },
      pageTypes: {
        page: {
          templates: [
            {
              name: 'Homepage',
              component: WoodshopnewsHomepageTemplate,
            },
          ],
        },
      },
    },
    [SiteId.TRADITIONALBUILDING]: {
      muiTheme: themes.traditionalbuilding,
      Header: headers.TraditionalbuildingHeader,
      blocks: {
        components: {
          AcfTopStoryBlock: AcfTopStoryBlockHeroLayout,
        },
      },
      extend: {
        blocks: [
          {
            name: 'acf/scriptmag-articles-showcase',
            component: AcfArticleShowcaseLayout,
            fragment: acfScriptmagArticlesShowcaseFragment,
          },
        ],
      },
      options: {
        disqusSiteIdentifier:
          nextConfig.publicRuntimeConfig?.disqusSiteIdentifier[
            SiteId.TRADITIONALBUILDING
          ],
        adConfig:
          nextConfig.publicRuntimeConfig?.adConfig[SiteId.TRADITIONALBUILDING],
      },
      pageTypes: {
        category: {
          templates: [
            {
              name: DIRECTORY_TEMPLATE_NAME,
              component: DirectoryTemplate,
              options: {
                paths: ['/buying-guides'],
                rootContent: TbDirectoryTemplateContent,
                childContent: DirectoryTemplateContent,
              },
            },
          ],
        },
        page: {
          templates: [
            {
              name: 'Homepage',
              component: TraditionalBuildingHomepageTemplate,
            },
          ],
        },
      },
    },
    [SiteId.PERIOD_HOMES]: {
      muiTheme: themes.periodHomes,
      Header: headers.PeriodHomesHeader,
      blocks: {
        components: {
          AcfTopStoryBlock: AcfTopStoryBlockHeroLayoutPH,
        },
      },
      extend: {
        blocks: [
          {
            name: 'acf/scriptmag-articles-showcase',
            component: AcfArticleShowcaseLayout,
            fragment: acfScriptmagArticlesShowcaseFragment,
          },
        ],
      },
      options: {
        disqusSiteIdentifier:
          nextConfig.publicRuntimeConfig?.disqusSiteIdentifier[
            SiteId.PERIOD_HOMES
          ],
        adConfig: nextConfig.publicRuntimeConfig?.adConfig[SiteId.PERIOD_HOMES],
      },
      pageTypes: {
        category: {
          templates: [
            {
              name: DIRECTORY_TEMPLATE_NAME,
              component: DirectoryTemplate,
              options: {
                paths: ['/buying-guides'],
                rootContent: PhDirectoryTemplateContent,
                childContent: PhDirectoryChildTemplateContent,
              },
            },
          ],
        },
        page: {
          templates: [
            {
              name: 'Homepage',
              component: PeriodHomesHomepageTemplate,
            },
          ],
        },
      },
    },
    [SiteId.TRADITIONALBUILDINGSHOW]: {
      muiTheme: themes.traditionalbuildingshow,
      Header: headers.TraditionalbuildingshowHeader,
      extend: {
        blocks: [
          {
            name: 'acf/scriptmag-articles-showcase',
            component: AcfArticleShowcaseLayout,
            fragment: acfScriptmagArticlesShowcaseFragment,
          },
        ],
      },
      options: {
        disqusSiteIdentifier:
          nextConfig.publicRuntimeConfig?.disqusSiteIdentifier[
            SiteId.TRADITIONALBUILDINGSHOW
          ],
        adConfig:
          nextConfig.publicRuntimeConfig?.adConfig[
            SiteId.TRADITIONALBUILDINGSHOW
          ],
      },
      pageTypes: {
        page: {
          templates: [
            {
              name: 'Homepage',
              component: TraditionalBuildingShowHomepageTemplate,
            },
          ],
        },
      },
    },
    [SiteId.NUMISMATICNEWS]: {
      muiTheme: themes.numismaticnews,
      Header: headers.NumismaticHeader,
      blocks: {
        components: {
          AcfTopStoryBlock: AcfTopStoryBlockHeroLayoutNN,
        },
      },
      extend: {
        blocks: [
          {
            name: 'acf/scriptmag-articles-showcase',
            component: AcfArticleShowcaseLayout,
            fragment: acfScriptmagArticlesShowcaseFragment,
          },
        ],
      },
      options: {
        disqusSiteIdentifier:
          nextConfig.publicRuntimeConfig?.disqusSiteIdentifier[
            SiteId.NUMISMATICNEWS
          ],
        adConfig:
          nextConfig.publicRuntimeConfig?.adConfig[SiteId.NUMISMATICNEWS],
      },
      pageTypes: {
        category: {
          templates: [
            {
              name: DIRECTORY_TEMPLATE_NAME,
              component: DirectoryTemplate,
              options: {
                paths: ['/directory'],
                rootContent: DirectoryTemplateContent,
                childContent: DirectoryTemplateContent,
              },
            },
          ],
        },
        page: {
          templates: [
            {
              name: 'Homepage',
              component: NumismaticNewsHomepageTemplate,
            },
          ],
        },
      },
    },
    [SiteId.OLDCARSWEEKLY]: {
      muiTheme: themes.oldcarsweekly,
      Header: headers.OldcarsweeklyHeader,
      blocks: {
        components: {
          AcfTopStoryBlock: AcfTopStoryBlockHeroLayoutOW,
        },
      },
      extend: {
        blocks: [
          {
            name: 'acf/scriptmag-articles-showcase',
            component: AcfArticleShowcaseLayout,
            fragment: acfScriptmagArticlesShowcaseFragment,
          },
        ],
      },
      options: {
        disqusSiteIdentifier:
          nextConfig.publicRuntimeConfig?.disqusSiteIdentifier[
            SiteId.OLDCARSWEEKLY
          ],
        adConfig:
          nextConfig.publicRuntimeConfig?.adConfig[SiteId.OLDCARSWEEKLY],
      },
      pageTypes: {
        page: {
          templates: [
            {
              name: 'Homepage',
              component: OldsCarWeeklyHomepageTemplate,
            },
          ],
        },
      },
    },
    [SiteId.SPORTSCOLLECTORSDIGEST]: {
      muiTheme: themes.sportscollectorsdigest,
      Header: headers.SportscollectorsdigestHeader,
      extend: {
        blocks: [
          {
            name: 'acf/scriptmag-articles-showcase',
            component: AcfArticleShowcaseSplitLayout,
            fragment: acfScriptmagArticlesShowcaseFragment,
          },
        ],
      },
      options: {
        disqusSiteIdentifier:
          nextConfig.publicRuntimeConfig?.disqusSiteIdentifier[
            SiteId.SPORTSCOLLECTORSDIGEST
          ],
        adConfig:
          nextConfig.publicRuntimeConfig?.adConfig[
            SiteId.SPORTSCOLLECTORSDIGEST
          ],
      },
      pageTypes: {
        category: {
          templates: [
            {
              name: DIRECTORY_TEMPLATE_NAME,
              component: DirectoryTemplate,
              options: {
                paths: ['/dealer-directory'],
                rootContent: ScdDirectoryTemplateContent,
                childContent: ScdDirectoryTemplateContent,
              },
            },
          ],
        },
        page: {
          templates: [
            {
              name: 'Homepage',
              component: SportsCollectorsDigestHomepageTemplate,
            },
          ],
        },
      },
    },
    [SiteId.ANTIQUETRADER]: {
      muiTheme: themes.antiquetrader,
      Header: headers.AntiquetraderHeader,
      extend: {
        blocks: [
          {
            name: 'acf/scriptmag-articles-showcase',
            component: AcfArticleShowcaseLayout,
            fragment: acfScriptmagArticlesShowcaseFragment,
          },
        ],
      },
      options: {
        disqusSiteIdentifier:
          nextConfig.publicRuntimeConfig?.disqusSiteIdentifier[
            SiteId.ANTIQUETRADER
          ],
        adConfig:
          nextConfig.publicRuntimeConfig?.adConfig[SiteId.ANTIQUETRADER],
      },
      pageTypes: {
        category: {
          templates: [
            {
              name: DIRECTORY_TEMPLATE_NAME,
              component: DirectoryTemplate,
              options: {
                paths: ['/directory-antique-businesses'],
                rootContent: AtDirectoryTemplateContent,
                childContent: AtDirectoryTemplateContent,
              },
            },
          ],
        },
        page: {
          templates: [
            {
              name: 'Homepage',
              component: AntiqueTraderHomepageTemplate,
            },
          ],
        },
      },
    },
    [SiteId.MILITARYTRADER]: {
      muiTheme: themes.militarytrader,
      Header: headers.MilitarytraderHeader,
      extend: {
        blocks: [
          {
            name: 'acf/scriptmag-articles-showcase',
            component: AcfArticleShowcaseLayout,
            fragment: acfScriptmagArticlesShowcaseFragment,
          },
        ],
      },
      options: {
        disqusSiteIdentifier:
          nextConfig.publicRuntimeConfig?.disqusSiteIdentifier[
            SiteId.MILITARYTRADER
          ],
        adConfig:
          nextConfig.publicRuntimeConfig?.adConfig[SiteId.MILITARYTRADER],
      },
      pageTypes: {
        category: {
          templates: [
            {
              name: DIRECTORY_TEMPLATE_NAME,
              component: DirectoryTemplate,
              options: {
                paths: ['/militaria-collecting-101/militaria-dealer-directory'],
                rootContent: MtDirectoryTemplateContent,
                childContent: MtDirectoryTemplateContent,
              },
            },
          ],
        },
        page: {
          templates: [
            {
              name: 'Homepage',
              component: DefaultHomepageTemplate,
            },
          ],
        },
      },
    },
    [SiteId.WRITERSDIGEST]: {
      muiTheme: themes.writersdigest,
      Header: headers.WritersdigestHeader,
      blocks: {
        components: {
          AcfTopStoryBlock: AcfTopStoryBlockArticleExcerptLayout,
        },
      },
      extend: {
        blocks: [
          {
            name: 'acf/scriptmag-articles-showcase',
            component: AcfArticleShowcaseLayout,
            fragment: acfScriptmagArticlesShowcaseFragment,
          },
        ],
      },
      options: {
        disqusSiteIdentifier:
          nextConfig.publicRuntimeConfig?.disqusSiteIdentifier[
            SiteId.WRITERSDIGEST
          ],
        adConfig:
          nextConfig.publicRuntimeConfig?.adConfig[SiteId.WRITERSDIGEST],
      },
      pageTypes: {
        page: {
          templates: [
            {
              name: 'Homepage',
              component: WritersDigestHomepageTemplate,
            },
            {
              name: 'wd-page',
              component: WritersdigestPageTemplate,
            },
          ],
          getTemplate: (page, _themeSettings, theme) => {
            if (page.uri === '/') {
              return getPageTemplateByName(theme, 'Homepage');
            }

            if (page.uri?.startsWith('/wd-competitions')) {
              return getPageTemplateByName(theme, 'wd-page');
            }

            return getPageTemplateByName(theme, DEFAULT_TEMPLATE_NAME);
          },
        },
      },
    },
    [SiteId.SCRIPTMAG]: {
      muiTheme: themes.scriptmag,
      Header: headers.ScriptmagHeader,
      blocks: {
        components: {
          AcfTopStoryBlock: AcfTopStoryBlockArticleLayout,
        },
      },
      extend: {
        blocks: [
          {
            name: 'acf/scriptmag-articles-showcase',
            component: AcfArticleShowcaseLayout,
            fragment: acfScriptmagArticlesShowcaseFragment,
          },
        ],
      },
      options: {
        disqusSiteIdentifier:
          nextConfig.publicRuntimeConfig?.disqusSiteIdentifier[
            SiteId.SCRIPTMAG
          ],
        adConfig: nextConfig.publicRuntimeConfig?.adConfig[SiteId.SCRIPTMAG],
      },
      pageTypes: {
        page: {
          templates: [
            {
              name: 'Homepage',
              component: DefaultHomepageTemplate,
            },
          ],
        },
      },
    },
  },
  getThemeIdByDomain: (domain, multiThemeProp) => {
    const defaultThemeId = Object.keys(multiThemeProp.variations)[0] as SiteId;

    if (!domain) {
      return defaultThemeId;
    }

    const hostname = getHostname(domain);
    if (!(hostname in multiThemeProp.variations)) {
      // eslint-disable-next-line no-console
      console.warn(
        `Could not find theme spec with ID ${hostname}. Using default theme instead.`
      );
      return defaultThemeId;
    }

    return hostname as SiteId;
  },
} as MultiTheme<SiteId>;

const theme = getTheme(SiteId.HORTMAG, multiTheme);

export default theme;
